import { createUseTranslation } from '@nexelem/services';
import { Translation } from '../translations/generic/pl';

export const useCustomTranslation = createUseTranslation<Translation>();
